import { t } from "i18next";
import { z } from "zod";

interface SignUp {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  confirmPassword: string;
  acceptTerms: boolean;
  occupation: string;
  occupationId: number;
}

export const SignUpSchema = (): z.ZodEffects<z.ZodType<SignUp>> =>
  z
    .object({
      firstName: z.string().min(2, t("schemas.signUp.firstName.min")),
      lastName: z.string().min(2, t("schemas.signUp.lastName.min")),
      email: z
        .string()
        .email(t("schemas.signUp.email.email"))
        .min(2, t("schemas.signUp.email.min")),
      password: z.string().min(2, t("schemas.signUp.password.min")),
      confirmPassword: z
        .string()
        .min(2, t("schemas.signUp.confirmPassword.min")),
      acceptTerms: z.boolean().refine((value) => value === true, {
        message: t("schemas.signUp.acceptTerms.refine"),
      }),
      occupation: z.string().min(1, t("schemas.signUp.occupation.min")),
      occupationId: z.number(),
    })
    .refine((data) => data.password === data.confirmPassword, {
      message: t("schemas.signUp.confirmPassword.refine"),
      path: ["confirmPassword"],
    });

export type SignUpSchemaType = z.infer<ReturnType<typeof SignUpSchema>>;
